import { NgModule } from '@angular/core';
import { AppComponent } from './containers/app/app';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppService } from './services/app.service';
import { UserService } from './services/user.service';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [],
  declarations: [
    AppComponent,
  ],
  providers: [
    AppService,
    UserService,
  ],
})
export class CoreModule {}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/core/core.module.ts